import { Certificate } from "@/models/certificate.model";
import { Pagination, QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class CertificateRest {
  static getAll(params?: Partial<QueryParams>): Observable<Pagination<Certificate>> {
    const url: string = `/certificates`;
    return api.get(url, params, "/graphs");
  }
}
